import config from "console_config";

export const isTrialEnded = () => {
  if (!config.CUSTOM_TRIAL_SUNSET_DATE) return false;

  const startingDate = new Date(config.CUSTOM_TRIAL_SUNSET_DATE);
  const now = new Date();

  return now > startingDate;
};
